module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "critter-list"
  }, _vm._l((_vm.creators), function(creator) {
    return _c('creator-detail', {
      key: creator,
      attrs: {
        "creator": creator
      }
    })
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-46273464!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CreatorList.vue
// module id = 756
// module chunks = 0